export const STORAGE_KEY = 'air_game_save';
export const SCHEMA_VERSION = 1;
export const DEFAULT_MAX_SPIRIT = 10;
export const DEFAULT_MAX_ACTIVE_CARDS = 15;
export const DEFAULT_CARDS_PER_TURN = 5;
export const DEFAULT_MAX_EQUIPMENT_SLOTS = 5;

export const STATE_KEYS = {
  SPIRIT: 'resources.spirit',
  DECK: 'deck',
  ACTIVE_CARDS: 'deck.activeCards',
  DECK_SLOTS: 'deck.slots',
  EQUIPMENT: 'equipment',
  ACTIVE_EQUIPMENT: 'equipment.active',
  MEMORIES: 'memories',
  ENCYCLOPEDIA: 'encyclopedia',
  BATTLE_RESOURCES: 'battle.resources',
  MAP_POSITION: 'map.playerPosition',
  RUN: 'run',
  BLUEPRINTS: 'blueprints',
  CONSTRUCTIONS: 'constructions',
  RESURRECTION: 'resurrection',
  TRAITS: 'traits',
  RELATIONS: 'relations'
};
